import React from 'react';
import './App.css';
import Arena from './components/world/Arena';

const App = () => {
  return (
    <div className="App">
      <Arena />
    </div>
  );
}

export default App;
